import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  // Estrae il pathname dall'oggetto location
  const { pathname } = useLocation();

  // useEffect viene eseguito ogni volta che il pathname cambia
  useEffect(() => {
    // Riporta la finestra all'inizio (coordinate 0, 0)
    window.scrollTo(0, 0);
  }, [pathname]); // La dipendenza [pathname] assicura che l'effetto venga eseguito solo al cambio di pagina

  // Questo componente non renderizza nulla nel DOM,
  // il suo unico scopo è eseguire l'effetto collaterale dello scroll.
  return null;
}

export default ScrollToTop;